import { Components, Theme } from '@mui/material';

const componentConfiguration: Components<Theme>['MuiIconButton'] = {
  defaultProps: {
    disableRipple: true
  }
};

export default componentConfiguration;
